import React, { ReactElement } from 'react';
import ReactDOM from 'react-dom';
import { createUseStyles } from 'react-jss';
import logger from 'logger';
import Routes from 'mockStores/components/Routes';

const useStyles = createUseStyles({
  mainContainer: {
    '& *': {
      /* fix Chrome not underlining letters properly https://bit.ly/3s5nhBS */
      'text-decoration-skip-ink': 'none',
    },
    '& a:visited': {
      color: 'inherit',
    },
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
});

function MockStores(): ReactElement {
  const classes = useStyles();

  return (
    <div className={ classes.mainContainer }>
      <Routes />
    </div>
  );
}

function renderDOM() {
  ReactDOM.render(
    <MockStores />,
    document.getElementById('honey'),
  );
}

export async function initMockStores(): Promise<void> {
  try {
    renderDOM();
  } catch (error) {
    logger.error('Error initializing MockStores', { error });
  }
}
